const data = {
  pageName: "PlanSelector",
  services: {
    translations: {
      url: "planSelector/translations",
      params: {}
    },
    data: {
      url: "planSelector/data",
      params: {}
    }
  },
  externalLinks: {
    allConvergentPlans: "/eshop/syndyastika-programmata/c-100176/",
    allFixedPlans: "/eshop/vodafone-home/c-120130/",
    convergentCheckoutPage: "/combo",
    fixedCheckoutPage: "/ftiakse-ti-statheri-sou/form"
  }
};

exports.data = data;
